import axiosInstance from './api';
import {
  EXTRACT_EVENT_DETAILS_PROMPT_MAX,
  EXTRACT_EVENT_DETAILS_TIMEOUT_MS,
} from '../components/Events/ManageEvent/eventFormConstants';
import {
  countFilledDescribeFields,
  mapExtractedEventDetailsToFormPatch,
} from '../components/Events/ManageEvent/parseEventDescribePrompt';

const getApiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  return (
    error.message ||
    error?.error?.message ||
    error?.data?.message ||
    error?.response?.data?.message ||
    fallback
  );
};

/**
 * POST /admin/extract-event-details — JSON `{ prompt }`; returns Add Event form fields.
 */
export const extractEventDetailsFromPrompt = async (prompt, { signal } = {}) => {
  const text = String(prompt ?? '').trim();
  if (!text) {
    return { success: false, message: 'Describe your event before generating.' };
  }

  if (text.length > EXTRACT_EVENT_DETAILS_PROMPT_MAX) {
    return {
      success: false,
      message: `Prompt must be at most ${EXTRACT_EVENT_DETAILS_PROMPT_MAX} characters.`,
    };
  }

  try {
    const response = await axiosInstance.post(
      '/admin/extract-event-details',
      { prompt: text },
      { timeout: EXTRACT_EVENT_DETAILS_TIMEOUT_MS, signal },
    );

    const payload = response.data;
    const data = payload?.data ?? payload;
    const formPatch = mapExtractedEventDetailsToFormPatch(data);

    if (countFilledDescribeFields(formPatch) === 0) {
      return {
        success: false,
        message: payload?.message || 'No event details could be extracted from the prompt.',
      };
    }

    return {
      success: true,
      eventDetails: data,
      formPatch,
      message: payload?.message || 'Event details extracted successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error, 'Failed to extract event details'),
      error,
    };
  }
};
